import { styled } from 'goober';
import { useTranslation } from 'react-i18next';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { WithHtmlSavvyTitle } from '@/with-html-savvy-title';

import { useAccountSwitchNotificationFromUrl } from '@/features/account/hooks/use-account-switch-notification-from-url';
import { FeedContent } from './feed-content';
import { FeedToolbar } from './feed-toolbar';

export const FeedPage = () => {
  const { t } = useTranslation('feed');

  useAccountSwitchNotificationFromUrl();

  return (
    <WithHtmlSavvyTitle title={t`page.title`}>
      <PageContainer direction="column" fullHeight>
        <FeedToolbar />
        <FeedContent />
      </PageContainer>
    </WithHtmlSavvyTitle>
  );
};

const PageContainer = styled(Flexbox)`
  min-height: 0;
  overflow: hidden;
`;
